import React, { useEffect } from "react";
import { eventActions } from "../../../_actions";
import { withTranslation, useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import Header from "../../../components/Header/Header";
import ".././Dashboard.scss";
import SearchBox from "../../../components/SearchBox/SearchBox";
import MaterialTable from "../../../components/MaterialTable/MaterialTable";
import AssignProductPopup from "../../../components/ModalPopup/AssignProductPopup";
import AuthorizedMessagePage from "../../../components/AuthorizedMessagePage";

function ProductMaster(props) {
  const dispatch = useDispatch();
  const assigncheck = useSelector((state) => state.assignproduct.assignproduct);
  const divisionList = useSelector((state) => state.getdivision.getdivision);
  const MyNewClass = useSelector(
    (state) => state.addclasswithstyle.addclasswithstyle,
  );
  const ProductMasterList = useSelector((state) => state.productmasterlist);
  const [searchValue, setSeachValue] = React.useState("");
  const [selectDivision, setSelectDivision] = React.useState("");

  let userName = localStorage.getItem("userData");
  userName = JSON.parse(userName);

  useEffect(() => {
    dispatch(eventActions.AssignProduct());
    dispatch(eventActions.getDivision(userName.countryCode));
  }, []);

  useEffect(() => {
    let filterData = [{ searchKey: searchValue }, { division: selectDivision }];

    dispatch(
      eventActions.productmasterList(userName.countryCode, 30, filterData, 1),
    );
  }, [userName.countryCode, searchValue, selectDivision]);

  return (
    <>
      <div className="content-wrapper">
        <Header title="Product Master" />

        <div className={"row ipad_css " + MyNewClass}>
          <div className="mainScroll">
            {ProductMasterList.error === "401" ? (
              <AuthorizedMessagePage />
            ) : (
              <div className="col-12 view_section">
                <div className="row mt-2 mb-2" style={{ alignItems: "center" }}>
                  <div className="col-4">
                    <SearchBox
                      handleSearchValue={setSeachValue}
                      placeholder="Search by Product name or Product Id"
                    />
                  </div>
                  <div className="col-2">
                    <div className="select-country">
                      <select
                        name=""
                        id=""
                        onChange={(event) =>
                          setSelectDivision(event.target.value)
                        }
                      >
                        <option value="">Select Division</option>
                        <option value="">All</option>
                        {divisionList
                          ? divisionList.map((divisionItem, index) => {
                              return (
                                <option value={divisionItem.value} key={index}>
                                  {divisionItem.value}
                                </option>
                              );
                            })
                          : null}
                      </select>
                    </div>
                  </div>
                  <div className="col-6 pr-2">
                    <div className="button_popup">
                      <AssignProductPopup
                        assigncheck={assigncheck}
                        title="Assign Product Group"
                      />
                    </div>
                  </div>
                </div>

                <div className="table-responsive table_design retaiter-table">
                  <MaterialTable
                    searchValue={searchValue}
                    selectDivision={selectDivision}
                  />
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default withTranslation()(ProductMaster);
